import styled from 'styled-components';
import theme from '../../styles/theme.css';

export const Container = styled.div`
    max-width: 100vw;
    background-color: ${props => props.bgColor};
    padding: 1.5rem 0;
    @media (max-width: 680px){
        padding: 1rem 0;
    }
    p{
        margin: 0;
    }
`